import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Home from "@/pages/Home";
import HowItWorks from "@/pages/HowItWorks";
import CreateMyAudio from "@/pages/CreateMyAudio";
import { initLenis, getLenis } from "@/lib/lenis";

function ScrollManager() {
  const location = useLocation();
  useEffect(() => {
    if (!location.hash) {
      const lenis = getLenis();
      if (lenis) lenis.scrollTo(0, { immediate: true });
      else window.scrollTo(0, 0);
    }
  }, [location.pathname]);
  return null;
}

function App() {
  useEffect(() => {
    initLenis();
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <ScrollManager />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/how-it-works" element={<HowItWorks />} />
          <Route path="/create-my-audio" element={<CreateMyAudio />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
